import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    root: {
      padding: 24,
      borderBottom: '1px solid',
      borderBottomColor: '#f0f0f0',
      display: 'flex',
      flexDirection: 'row',
      background: 'transparent',
      alignItems: 'center',
      position: 'relative',
      ':hover': {
        background: 'rgba(0,0,0,0.02)',
        cursor: 'pointer'
      }
    },
    noHover: {
      ':hover': {
        background: 'transparent',
        cursor: 'default'
      },
    },
    expandIcon: {
      color: 'grey',
      fontSize: 16,
      transition: '200ms',
      position: 'absolute',
      top: 24,
      right: 24
    },
    expandedIcon: {
      transform: 'rotate(180deg)'
    }
  }
);

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/content-row/content-row-styles.js